export enum MatchReportTypeEnum {
    DEFAULT,
    MATCH, 
    VOIDGAP
}